import { useEffect } from 'react';
import { useAppDispatch } from '../store';
import { SESSION_STORAGE_TOKEN_KEY } from '../constants';
import { setUserToken, setUuid } from '../store/signup';

export const useSetTokens = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const storageToken = window.sessionStorage?.getItem(SESSION_STORAGE_TOKEN_KEY);
    if (storageToken) dispatch(setUserToken(storageToken));

    setUuid()(dispatch);
  });
};
